import { render, staticRenderFns } from "./Quidel.vue?vue&type=template&id=36fe3b69&"
import script from "./Quidel.vue?vue&type=script&lang=ts&"
export * from "./Quidel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports